import { useState, useEffect } from 'react';

// Loadable Import
import loadable from '@loadable/component';

// UUID Import
import { v4 } from 'uuid';

// Routing Import
import { Switch, Route } from "react-router-dom";

// Axios Import
import axios from 'axios';

// Loader Imports
import { css } from "@emotion/react";
import FadeLoader from "react-spinners/FadeLoader";

// React Toast Imports
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Bootstrap component Import
import { Container } from 'reactstrap';

// SVG Import
import { ReactComponent as Error } from '../../assets/media/error.svg';

// Get Data
// import { data } from '../../data';

// Environment variables
const { REACT_APP_ID, REACT_APP_KEY } = process.env

// Custom components
const SearchForm = loadable(() => import('./SearchForm'))
const Recipe = loadable(() => import('./Recipe'))
const RecipeDetails = loadable(() => import('./RecipeDetails'))


const RecipeList = () => {

	// Variable states
	const [foodRecipes, setFoodRecipes] = useState([]);
	const [food, setFood] = useState("");
	const [loading, setLoading] = useState(false);

	// API call function for searching
	const search = async(searchString, load) => {
		// Url to search from
		let url = `https://api.edamam.com/search?q=${searchString}&app_id=${REACT_APP_ID}&app_key=${REACT_APP_KEY}`;

		// Set the loader to load argument
		setLoading(load)

		// Get data from url
		await axios.get(url).then(res => {

			// If the response is an empty list return an display a toast
			if (res.data.hits.length < 1) {
				errorMessage();
				setFoodRecipes([])
				setLoading(false)
			}else{
				setFood(searchString)
				setFoodRecipes(res.data.hits)
				setLoading(false)
			}

		}).catch(error => {
			setFoodRecipes([])
			setLoading(false)
		})
	}

	// React toast style and message
	const errorMessage = () => toast.error(`Could not find what you are looking for, try something else`, {
		position: "bottom-center",
		autoClose: 5000,
		hideProgressBar: false,
		closeOnClick: true,
		pauseOnHover: true,
		draggable: true,
		progress: undefined,
	});

	// Show and hide loader when component renders
	useEffect(() => {
		setLoading(true)

		setTimeout(() => {
			setLoading(false)
		}, 1000);
	}, [])

	return (
		<Container className="content">
			{/* Switch between routes */}
			<Switch>
				<Route exact path="/">
					<SearchForm  search={search} />
					<ToastContainer />
					<div className="food">
						{/* Display loader if loading is true else display the recipes */}
						{loading ? 
							<div className="loader">
								<FadeLoader css={css} size={60} loading={loading} />
								<small className="mt-3">Loading...</small>
							</div>
						:
							foodRecipes && foodRecipes.length > 0 ? (
									<>
										<h5 className="food-header">Recipes for {food}</h5>
										<div className="recipes">
											{foodRecipes.map(recipe => (
												<Recipe key={v4().slice(0, 8)} recipe={recipe.recipe} />
											))}
										</div>
									</>
								)
							: 
							// Return an empy page if foodRecipes is empty
								<div className="empty">
									<h5>No recipes for your search</h5>
									<div className="error">
										<Error />
									</div>
								</div>
						}
					</div>
				</Route>
				<Route path="/:recipe">
					<div className="graph">
						<RecipeDetails recipe={foodRecipes} />
					</div>
				</Route>
			</Switch>
		</Container>
	)
}

export default RecipeList
